import { Box, Paper, Button, Chip, Snackbar, Alert, Stack, Tooltip } from '@mui/material';
import { customBgWhite } from '@old/styles/generic-styles';
import {
  setHistoricalPoeImgs,
  setSiloMetricImg,
  setExtractionImgs,
  setDesvSilometricImg,
  formatDateTime,
} from '@old/utils/helper';
import { BaseTable } from '@old/ui/table';
import { GridColDef } from '@mui/x-data-grid-pro';
import { PoeModal } from './poe-silobag-modal';
import { useState } from 'react';
import { CarouselModalPhotoGallery } from '@old/ui/carousel/carousel';
import { useEffectOnUpdate, useToggle } from '@old/hooks/core';
import { useService } from '@old/hooks/use-service';
import { GenerateExtractionsExcelData } from '@old/utils/export-files';
import { useParams } from 'react-router';
import i18n from '../../../../libs/language';
import { ExtractionAction } from '../exctraction-modal';
import { EditSBModal } from './edit-silobag-modal';
import { SILOBAG_EVENTS_IDS } from '@old/data/to-refactor/constants';
import viewIcon from '@old/assets/svg/view_blue.svg';
import imgIcon from '@old/assets/svg/img.svg';
import GreenUpArrow from '@old/assets/svg/core/arrow-upward-green.svg';
import RedDownArrow from '@old/assets/svg/core/arrow-downward-red.svg';
import { extractionListService } from '@old/services/domain/base/silobag/extraction/extraction-list';
import downloadArchiveIcon from '@old/assets/svg/download_blue.svg';
import BlueEyeIcon from '@old/assets/svg/view_blue.svg';
import { LabHistoryModal } from '../modal/laboratory/laboratory-history-modal';
import { silobagDataDetailService } from '@old/services/domain/base/silobag/base/silobag-data-detail';
import { MobileCloseModal } from './mobile-close-modal';
import { createExtractionService } from '@old/services/domain/base/silobag/extraction/extraction-creation';
import { PoeV2SilobagModal } from './poe-v2-silobag-modal';
import { ExtractionSatViewModal } from './extraction-sat-view-modal';
import { SharedIDModal } from '../modal/shared-id/shared-id-modal';
import { InsuranceModal } from '../modal/insurance/insurance';

type SummarySilobagDetail = Awaited<ReturnType<typeof silobagDataDetailService>>['summary'];

type PoeSummary = SummarySilobagDetail['poe'];
type Poe2Summary = SummarySilobagDetail['silobags_history'][0]['poe_v2'];

type SatViewExtractionEvent = SummarySilobagDetail['silobags_history'][0]['sat_view_events'];
type SilobagsVersions = SummarySilobagDetail['silobags_history'][0]['silobags_versions']['data'];
type SilobagSharedPermissionData = SummarySilobagDetail['silobags_history'][0];
type SilobagInsuranceData = SummarySilobagDetail['silobags_history'][0]; // falta completar el tipado con la nueva respuesta del back

type SilobagHistoricalProps = {
  data?: SummarySilobagDetail;
  isLoading: boolean;
  Poe?: PoeSummary;
};

type ImageData = {
  url: string;
  label?: string | null;
  init_azimuth?: string | null;
  init_timestamp?: string | bigint | null;
  init_lat?: string | null;
  init_lon?: string | null;
  init_accuracy?: string | number | null;
  main_azimuth?: string | null;
  main_timestamp?: string | bigint | null;
  main_lat?: string | null;
  main_lon?: string | null;
  main_accuracy?: string | number | null;
  end_azimuth?: string | null;
  end_timestamp?: string | bigint | null;
  end_lat?: string | null;
  end_lon?: string | null;
  end_accuracy?: string | number | null;
  init_observations?: string | null;
};
type CreateExtractionService = Awaited<ReturnType<typeof createExtractionService>>['summary'];
export function HistorySection({ data, isLoading, Poe }: SilobagHistoricalProps) {
  const { siloID } = useParams();
  const [modalPoe, setModalPoe] = useState(false);
  const [modalPoe2, setModalPoe2] = useState(false);
  const [modalEditSB, setModalEditSB] = useState(false);
  const [eventId, setEventId] = useState<number>();
  const [dataSb, setDataSb] = useState<SilobagsVersions>();
  const [ModifiedData, setModifiedData] = useState<SilobagsVersions>(); // foundRow?.silobags_versions?.data
  const [modalImage, setModalImage] = useToggle(false);
  const [images, setImages] = useState<ImageData[]>([]);
  const [openModalImages, setOpenModalImages] = useToggle(false);
  const [modalExtraction, setModalExtraction] = useToggle(false);
  const [extractionData, setExtractionData] = useState<CreateExtractionService>();
  const [remainingStock, setRemainingStock] = useState<number | string | null>(0);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [type, setType] = useState<'view' | 'edit'>('view');
  const [openSnackbar, setOpenSnackbar] = useToggle(false);
  const [typeSnackbar, setTypeSnackbar] = useState<'success' | 'error'>('success');
  const [extractionID, setExtractionID] = useState<number>();
  const [openMobileModal, setOpenMobileModal] = useToggle(false);
  const [openLabModal, toggleOpenLabModal] = useToggle(false);
  const [poe2Data, setPoe2Data] = useState<Poe2Summary>();
  const handleOpenLabModal = () => toggleOpenLabModal(true);
  const handleCloseLabModal = () => toggleOpenLabModal(false);

  const [targetSatViewExtraction, setTargetSatViewExtraction] = useState<SatViewExtractionEvent>(null);
  const [modalSatViewExtraction, setModalSatViewExtraction] = useState(false);
  const handleOpenSatViewExtractionModal = (e: SatViewExtractionEvent) => {
    setTargetSatViewExtraction(e);
    setModalSatViewExtraction(true);
  };
  const handleCloseSatViewExtractionModal = () => {
    setTargetSatViewExtraction(null);
    setModalSatViewExtraction(false);
  };

  const [detailAboutSharedID, setDetailAboutSharedID] = useState<SilobagSharedPermissionData | null>(null);
  const handleDetailAboutSharedIDModalClose = () => setDetailAboutSharedID(null);

  const [detailAboutInsurance, setDetailAboutInsurance] = useState<SilobagInsuranceData | null>(null);
  const handleDetailAboutInsuranceModalClose = () => setDetailAboutInsurance(null);

  const originalRows = data?.silobags_history !== undefined ? data?.silobags_history : [];
  const eventWeb = data?.silobags_history?.some((item) => item.silobag_event_type_id === 16);
  const eventMobile = data?.silobags_history?.some((item) => item.silobag_event_type_id === 14);

  const handleClosePoe2Modal = () => setModalPoe2(false);

  const rows = originalRows.map((item, index: number) => ({
    ...item,
    isFirst: index === 0,
    isLast: index === originalRows.length - 1,
  }));

  const dataPoe = Poe !== undefined ? Poe : [];
  const handleOpenPoe = (event_id: number) => {
    setModalPoe(true);
    setEventId(event_id);
  };

  const handleOpenPoe2 = (poe_data: Poe2Summary) => {
    setModalPoe2(true);
    setPoe2Data(poe_data);
    setEventId(33);
  };

  const handleOpenEditSB = (EditHistoryId: number) => {
    if (!EditHistoryId || !data?.silobags_history) return;

    const foundRow = data.silobags_history.find((item: { id: number }) => item.id === EditHistoryId);

    if (!foundRow) return;

    const correctData = data?.silobags_history.filter(
      (arr) =>
        arr.silobag_event_type_id === SILOBAG_EVENTS_IDS.EDICION_SILOBOLSA ||
        arr.silobag_event_type_id === SILOBAG_EVENTS_IDS.ALTA_SILOBOLSA ||
        arr.silobag_event_type_id === SILOBAG_EVENTS_IDS.ALTA_CAMPO ||
        arr.silobag_event_type_id === SILOBAG_EVENTS_IDS.ALTA_WEB ||
        arr.silobag_event_type_id === SILOBAG_EVENTS_IDS.COMPLETADO_DATOS ||
        arr.silobag_event_type_id === SILOBAG_EVENTS_IDS.EMBOLSADO
    );

    const currentVersionIndex = correctData?.findIndex((item: { id: number }) => item.id === EditHistoryId);

    const previousVersion = correctData[currentVersionIndex + 1];

    setModifiedData(foundRow?.silobags_versions?.data);
    setDataSb(previousVersion?.silobags_versions?.data);
    setModalEditSB(true);
  };
  const mainImage = data?.main_image;
  const initImage = data?.init_image;
  const endImage = data?.end_image;

  const silobag_actions = data?.silobags_actions;

  const imagesSilo = [
    {
      url: initImage ?? '',
      label: initImage !== null ? `Imagen inicial` : '',
      init_azimuth: data?.init_azimuth,
      init_timestamp: data?.init_timestamp,
      init_lat: data?.init_lat,
      init_lon: data?.init_lon,
      init_accuracy: data?.init_accuracy,
    },
    {
      url: mainImage ?? '',
      label: mainImage !== null ? `Imagen principal` : '',
      main_azimuth: data?.main_azimuth,
      main_timestamp: data?.main_timestamp,
      main_lat: data?.main_lat,
      main_lon: data?.main_lon,
      main_accuracy: data?.main_accuracy,
    },
    {
      url: endImage ?? '',
      label: endImage !== null ? `Imagen final` : '',
      end_azimuth: data?.end_azimuth,
      end_timestamp: data?.end_timestamp,
      end_lat: data?.end_lat,
      end_lon: data?.end_lon,
      end_accuracy: data?.end_accuracy,
    },
  ].filter((image) => image.url != null);

  if (mainImage !== null || initImage !== null || endImage !== null) {
    if (silobag_actions && silobag_actions?.length > 0) {
      silobag_actions.map((action) => {
        if (action?.image !== null) {
          imagesSilo.push({
            url: action?.image,
            label: 'Fotos Extras',
            init_azimuth: action?.azimuth,
            init_timestamp: action?.timestamp,
            init_lat: action?.lat,
            init_lon: action?.lon,
            init_accuracy: action?.accuracy,
          });
        }
      });
    }
  }

  const handleModalImageOpen = (eventId: number, deviceIdOrPoeId: string | number) => {
    switch (eventId) {
      case SILOBAG_EVENTS_IDS.EXTRACCION: //Extracción
        setExtractionImgs(deviceIdOrPoeId as number, data, setImages);
        setModalImage(true);
        break;
      case SILOBAG_EVENTS_IDS.RECORRIDA: //Poe
        setHistoricalPoeImgs(deviceIdOrPoeId as number, data, setImages);
        setModalImage(true);
        break;
      case SILOBAG_EVENTS_IDS.ARCHIVO: // Descargar archivo
        return null;
      case SILOBAG_EVENTS_IDS.ALTA_SILOBOLSA: //Silobag
      case SILOBAG_EVENTS_IDS.COMPLETADO_DATOS: //Silobag completado datos
      case SILOBAG_EVENTS_IDS.ALTA_CAMPO: //Silobag
      case SILOBAG_EVENTS_IDS.ALTA_WEB: //Silobag alta web
        setImages(imagesSilo);
        setModalImage(true);
        break;
      case SILOBAG_EVENTS_IDS.EMBOLSADO: //Embolsado
        return null;
      case SILOBAG_EVENTS_IDS.ADICION_SILOMETRIX: // Vinculacion de SiloMetrix
        setSiloMetricImg(deviceIdOrPoeId as number, data, setImages);
        setModalImage(true);
        break;
      case SILOBAG_EVENTS_IDS.DESVINCULACION_SILOMETRIX: // Desvinculacion de SiloMetrix
        setDesvSilometricImg(deviceIdOrPoeId as number, data, setImages);
        setModalImage(true);
        break;
    }
  };

  //Extractions Service and hook
  const {
    trigger: getExtracions,
    summary: dataExtractions,
    isLoading: isLoadingExtractions,
  } = useService(extractionListService);

  useEffectOnUpdate(() => {
    if (!isLoadingExtractions && dataExtractions) {
      GenerateExtractionsExcelData(dataExtractions, siloID);
    }
  }, [!isLoadingExtractions]);

  const ShowExtractionDetail = (extractionData: CreateExtractionService, remainingStock: number) => {
    setExtractionData(extractionData);
    setExtractionID(extractionData.id as number);
    setRemainingStock(remainingStock);
    setModalExtraction(true);
  };
  const enableEditMode = () => setType('edit');

  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  type LabProtocolSummary = Awaited<
    ReturnType<typeof silobagDataDetailService>
  >['summary']['lab_protocols_history'][0];

  const [targetProtocol, setTargetProtocol] = useState<LabProtocolSummary>();

  const STATE = {
    OPENED_ORIGIN: 15,
    OPENED_WEB: 16,
    CLOSED: 6,
  };
  const isOpenedOrClosedState = (id: number) =>
    id === STATE.OPENED_WEB || id === STATE.OPENED_ORIGIN || id === STATE.CLOSED;
  const columns: GridColDef[] = [
    {
      field: 'created_at',
      display: 'flex',
      headerName: i18n.t('app.date'),
      flex: 1,
      minWidth: 160,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              position: 'relative',
              marginRight: 2,
              '&:before': {
                content: params.api.getSortedRowIds().at(0) === params.row.id ? 'none' : '""',
                position: 'absolute',
                bottom: 1,
                left: -1,
                width: '2px',
                height: '30px',
                backgroundColor: '#49454F',
                zIndex: 1,
              },
              '&:after': {
                content: params.api.getSortedRowIds().at(-1) === params.row.id ? 'none' : '""',
                position: 'absolute',
                top: 1,
                left: -1,
                width: '2px',
                height: '30px',
                backgroundColor: '#49454F',
                zIndex: 1,
              },
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                transform: 'translate(-50%, -50%)',
                width: isOpenedOrClosedState(params.row.silobags_history_event_types.id) ? '14px' : '8px',
                height: isOpenedOrClosedState(params.row.silobags_history_event_types.id) ? '14px' : '8px',
                borderRadius: '50%',
                backgroundColor: '#49454F',
              }}
            />
          </Box>
          <span>{formatDateTime(params.value, 3)}</span>
        </Box>
      ),
    },
    {
      field: 'silobags_history_event_types',
      display: 'flex',
      headerName: 'Evento',
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        const description =
          params.value.silobags_history_event_types_translations?.[0]?.description ??
          params.value.description;
        const isRecorrida = description === 'Recorrida' || description === 'Existência';
        const isValid = params.row.poe_v2?.valid ?? params.row.poe?.valid ?? null;
        const chipLabel =
          isRecorrida && (isValid === null || isValid === false) ? `${description} 🔴` : description;

        const chip = (
          <Chip
            label={chipLabel}
            sx={{
              backgroundColor: params.value.bk_color,
              color: params.value.text_color,
              fontSize: '11px',
              fontWeight: 'bold',
              borderRadius: '8px',
            }}
          />
        );
        return isRecorrida && (isValid === null || isValid === false) ? (
          <Tooltip title={i18n.t('app.silobag_history.poe_warning')}>{chip}</Tooltip>
        ) : (
          chip
        );
      },
    },
    {
      field: 'egress',
      display: 'flex',
      headerName: i18n.t('app.stock_movement'),
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => {
        const hasIncomeValue = params.row.income !== null;
        const hasEgressValue = params.value !== null;

        // Default settings
        let displayValue = '―';
        let styles = {};
        let icon;

        // Income settings
        if (hasIncomeValue) {
          const delimitedValue = i18n.numberToDelimited(params.row.income, {
            delimiter: i18n.t('config.delimiter'),
          });
          displayValue = `${delimitedValue} kg`;
          styles = { color: '#73BD00', fontWeight: 500 };
          icon = GreenUpArrow;
        }

        // Egress settings
        if (hasEgressValue) {
          const delimitedValue = i18n.numberToDelimited(params.value, {
            delimiter: i18n.t('config.delimiter'),
          });
          displayValue = `${delimitedValue} kg`;
          styles = { color: '#FF0000', fontWeight: 500 };
          icon = RedDownArrow;
        }

        return (
          <span style={styles}>
            {' '}
            <img src={icon} /> {displayValue}
          </span>
        );
      },
    },
    {
      field: 'remaining_stock',
      display: 'flex',
      headerName: i18n.t('app.silobag_data.remaining_stock'),
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <span>
          {i18n.numberToDelimited(parseInt(params.value), { delimiter: i18n.t('config.delimiter') })} kg
        </span>
      ),
    },
    {
      field: 'silobags_history_statuses',
      display: 'flex',
      headerName: 'Estado',
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" gap={0.7}>
          <Box
            sx={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: params.value.color,
            }}
          />
          <Box>{params.value.description}</Box>
        </Stack>
      ),
    },
    {
      field: 'users',
      display: 'flex',
      headerName: 'Usuario',
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: (params) => <span>{params.value?.fullname}</span>,
    },
    {
      field: 'detail',
      display: 'flex',
      headerName: i18n.t('app.detail'),
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => {
        const detailID = params.row.silobags_history_event_types.id;
        const poe_id = parseInt(params.row.poe_id, 10);
        // const poe_2_id = parseInt(params.row, 10);
        // TODO: CREAR UN ARRAY CONSTANTE CON LOS IDS.
        const excludeImagesButton = [
          2, 3, 5, 6, 7, 8, 16, 17, 18, 19, 21, 20, 22, 23, 24, 25, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
        ];
        const hasDetailButton = [2, 7, 19, 21, 20, 33, 36, 37, 39, 40, 41].includes(detailID);
        // const editSbVersion = params.row.silobags_versions
        //   ? parseInt(params.row.silobags_versions.id, 10)
        //   : null;
        const EditHistoryId = parseInt(params.row.id, 10);

        const poe_v2_data = params.row?.poe_v2 ?? undefined;

        const labModalAction = () => {
          const protocolID = params.row.lab_protocol_history_id;
          //TODO FALTO TIPAR DESARROLLO LAB
          const protocolHistory = data?.lab_protocols_history;

          const newTargetProtocol = protocolHistory!.find((protocol) => protocol.id === protocolID);
          setTargetProtocol(newTargetProtocol);
          handleOpenLabModal();
        };

        const actionMap: { [key: number]: () => void } = {
          2: () => handleOpenPoe(poe_id),
          7: () => handleOpenEditSB(EditHistoryId),
          19: () => setOpenMobileModal(true),
          20: labModalAction,
          21: labModalAction,
          33: () => handleOpenPoe2(poe_v2_data),
          36: () => handleOpenSatViewExtractionModal(params.row.sat_view_events),
          37: () => setDetailAboutInsurance(params.row),
          39: () => setDetailAboutSharedID(params.row),
          40: () => setDetailAboutSharedID(params.row),
          41: () => setDetailAboutSharedID(params.row),
        };

        return (
          <Box>
            {hasDetailButton ? (
              <Button
                startIcon={<img src={viewIcon} style={{ width: 18, height: 15 }} />}
                style={{ color: '#09AAEB', textTransform: 'none' }}
                onClick={actionMap[detailID]}
              >
                {i18n.t('app.detail')}
              </Button>
            ) : null}
            {!excludeImagesButton.includes(detailID) && (
              <Button
                startIcon={<img src={imgIcon} style={{ width: 16, height: 13 }} />}
                sx={{ fontSize: '14px', color: '#09AAEB', textTransform: 'none' }}
                onClick={() =>
                  handleModalImageOpen(
                    detailID,
                    params.row.silobag_device_id || params.row.poe_id || params.row.id
                  )
                }
              >
                {i18n.t('app.images')}
              </Button>
            )}
            {detailID === 3 ? (
              <a download href={params.row.files?.file_path}>
                <Button
                  startIcon={<img src={downloadArchiveIcon} alt="download" />}
                  sx={{ fontSize: '14px', color: '#09AAEB', textTransform: 'none' }}
                >
                  {i18n.t('app.silobag_history.download_file')}
                </Button>
              </a>
            ) : null}
            {detailID === 6 ? (
              <Button
                startIcon={<img src={downloadArchiveIcon} alt="download" />}
                sx={{ fontSize: '14px', color: '#09AAEB', textTransform: 'none' }}
                onClick={getExtracions}
              >
                {i18n.t('app.silobag_history.resumen')}
              </Button>
            ) : null}
            {(detailID === 1 || detailID === 8) && (
              <Button
                startIcon={<img src={BlueEyeIcon} alt="extraction-detail" />}
                sx={{ fontSize: '14px', color: '#09AAEB', textTransform: 'none' }}
                onClick={() =>
                  ShowExtractionDetail(
                    params?.row?.silobags_extractions_versions?.data,
                    params?.row?.remaining_stock
                  )
                }
              >
                {i18n.t('app.silobag_history.extraction')}
              </Button>
            )}
          </Box>
        );
      },
    },
  ];
  return (
    <>
      <Paper elevation={0} sx={customBgWhite}>
        {openModalImages && (
          <CarouselModalPhotoGallery
            open={openModalImages}
            onClose={setOpenModalImages}
            images={images}
            title="Imagenes"
            sbId={data?.id}
          />
        )}
        {PoeModal && (
          <PoeModal
            open={modalPoe}
            setOpen={setModalPoe}
            data={dataPoe}
            poeId={eventId}
            eventWeb={eventWeb}
            eventMobile={eventMobile}
          />
        )}
        {modalPoe2 && <PoeV2SilobagModal open={modalPoe2} onClose={handleClosePoe2Modal} data={poe2Data} />}
        {modalEditSB && (
          <EditSBModal
            open={modalEditSB}
            setOpen={setModalEditSB}
            dataSb={dataSb as SummarySilobagDetail}
            modifiedDataSb={ModifiedData as SummarySilobagDetail}
          />
        )}
        {modalImage && (
          <CarouselModalPhotoGallery
            open={modalImage}
            onClose={setModalImage}
            images={images}
            title="Imagenes"
            sbId={data?.id}
          />
        )}
        {openLabModal ? (
          <LabHistoryModal
            open={openLabModal}
            onClose={handleCloseLabModal}
            data={targetProtocol!}
            siloSpecies={data?.silobag_species_types.silobag_species_types_translations[0].description}
            siloVariety={data?.variety}
          />
        ) : null}
        {openMobileModal && (
          <MobileCloseModal
            open={openMobileModal}
            setOpen={setOpenMobileModal}
            data={data?.silobags_history}
          />
        )}
        {modalSatViewExtraction ? (
          <ExtractionSatViewModal
            open={modalSatViewExtraction}
            target={targetSatViewExtraction}
            onClose={handleCloseSatViewExtractionModal}
          />
        ) : null}
        <Box component="h1" margin={0}>
          {i18n.t('app.silobag_data.history')}
        </Box>
        <BaseTable rows={rows ?? []} columns={columns} initialPageSize={10} loading={isLoading} noBorders />
      </Paper>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleClose} severity={typeSnackbar} variant="filled" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      {/* // TODO: ❌ TypeScript Error: ExtractionAction no tiene la propiedad 'siloTrigger' porque es un modal que no admite modificaciones por lo que no tiene que hacer refresh al vuelo */}
      {modalExtraction && (
        <ExtractionAction
          active={data?.active}
          extractionData={extractionData as CreateExtractionService}
          silobagOrExtractionId={extractionID}
          siloName={data?.name}
          type={type}
          fromHistory={true}
          open={modalExtraction}
          setOpen={setModalExtraction}
          remainingStock={remainingStock}
          setRemainingStock={setRemainingStock}
          setSnackbarMessage={setSnackbarMessage}
          setTypeSnackbar={setTypeSnackbar}
          setOpenSnackbar={setOpenSnackbar}
          enableEditMode={enableEditMode}
        />
      )}
      {detailAboutSharedID !== null ? (
        <SharedIDModal
          open={detailAboutSharedID !== null}
          name={{
            organization: detailAboutSharedID.user_silobags_permissions_versions.organizations.name,
            user: detailAboutSharedID.user_silobags_permissions_versions.users.fullname,
          }}
          permissions={{
            current: {
              read: detailAboutSharedID.user_silobags_permissions_versions.read_permission,
              write: detailAboutSharedID.user_silobags_permissions_versions.write_permission,
              full: detailAboutSharedID.user_silobags_permissions_versions.full_permission,
            },
            previous: {
              read: detailAboutSharedID.user_silobags_permissions_versions?.previous_version?.read_permission,
              write:
                detailAboutSharedID.user_silobags_permissions_versions?.previous_version?.write_permission,
              full: detailAboutSharedID.user_silobags_permissions_versions?.previous_version?.full_permission,
            },
          }}
          extra={{
            event:
              detailAboutSharedID.silobags_history_event_types.silobags_history_event_types_translations[0]
                .description,
            siloID: detailAboutSharedID.user_silobags_permissions_versions.silobag_id,
            date: detailAboutSharedID.user_silobags_permissions_versions.created_at,
          }}
          onClose={handleDetailAboutSharedIDModalClose}
        />
      ) : null}
      {detailAboutInsurance !== null ? (
        <InsuranceModal
          open={detailAboutInsurance !== null}
          onClose={handleDetailAboutInsuranceModalClose}
          entry={detailAboutInsurance}
        />
      ) : null}
    </>
  );
}
